export enum FormViewMode {
  FullAccsess = 1,
  ReadOnly = 2,
  Edit = 3,
}
